export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./create.vue?vue&type=template&id=1c9be386"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/create.vue?vue&type=template&id=1c9be386
// module id = w8kn
// module chunks = 0